import { Component } from '@angular/core';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { PartnerAnalysisGroup3 } from 'src/app/assabil-kernel/models/entities/control-tables/partner-analysis-group3';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { PartnerAnalysisGroup3Request } from 'src/app/assabil-kernel/models/dtos/control-tables/partner-analysis-group3-request';

@Component({
  selector: 'app-partner-analysis-group3-list',
  templateUrl: './partner-analysis-group3-list.component.html',
  styleUrls: ['./partner-analysis-group3-list.component.scss']
})
export class PartnerAnalysisGroup3ListComponent  extends BasePage2<PartnerAnalysisGroup3> {

  // Filter fields
  // ---------------------------------------------------
  code: string;
  name: string;
  // ---------------------------------------------------
      
  // ---------------------------------------------------
  partnersAnalysisGroups: PartnerAnalysisGroup3[] = [];
  // ---------------------------------------------------
  

  constructor(
      protected toastr            : ToastrService,
      protected controlService    : ControlTablesService,
      protected router            : Router,
      protected baseService       : BaseService,
      protected leanUtilsService  : LeanUtilsService,
      protected location          : Location) {
      super(toastr, router, baseService, leanUtilsService, location);

      this.entityName = 'partnerAnalysisGroup3';
  }


  listFields = [
      { prop: 'partnerAnalysisGroup3Code', name: 'Code',  insertOnly : true},
      { prop: 'name', name: 'Name' },
      { prop: 'rank', name: 'Rang' }
  ]

  getRows(): PartnerAnalysisGroup3[] {
      return this.partnersAnalysisGroups;
  }

//----------------------------------------------------------------------
saveRow(partnerAnalysisGroup3: PartnerAnalysisGroup3): Promise<PartnerAnalysisGroup3> {
  let request  : PartnerAnalysisGroup3Request = new PartnerAnalysisGroup3Request(this.controlService.getUserInfo());
  request.partnerAnalysisGroup3 = partnerAnalysisGroup3;
    return this.controlService.save(this.entityName, request);
}
//----------------------------------------------------------------------

  //----------------------------------------------------------------------
  new(){
    let entity : PartnerAnalysisGroup3 = new PartnerAnalysisGroup3();
    entity.inserted = true;
    entity.edit = true;
    this.partnersAnalysisGroups.push(entity);
    this.partnersAnalysisGroups = [...this.partnersAnalysisGroups];
    }
//----------------------------------------------------------------------

  loadData() {
    let request         : BaseRequest = this.controlService.getRequest();
    request.strArg1 = this.code;
    request.strArg2 = this.name;

    this.controlService.getList(this.entityName, request).then(result => {
        this.partnersAnalysisGroups = result;
        
    }).catch(error => {
        this.showError(error);
    })
  }

  }
